

import { useState, useCallback, useContext, useEffect, useRef,  } from "react";
import Chart from "react-apexcharts";
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from '../../ContextApi/ContextApi';

const getMonthStartAndEndDate = (month, year) => {
    // Create the start date of the given month
    const startDate = new Date(year, month - 1, 1);

    // Create the end date by setting the day to 0 of the next month
    const endDate = new Date(year, month, 0);

    // Format the dates as 'YYYY-MM-DD'
    const formattedStartDate = `${startDate.getFullYear()}-${String(startDate.getMonth() + 1).padStart(2, '0')}-${String(startDate.getDate()).padStart(2, '0')}`;
    const formattedEndDate = `${endDate.getFullYear()}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;

    return { startDate: formattedStartDate, endDate: formattedEndDate };
};

function SourcingChart() {
  const series = [33, 22, 12, 8];
  const labels = ["Offer Letters Sent", "Final Selection", "Joined", "Backouts"];

  const options = {
    chart: { type: "bar", stacked: true, height: 100, toolbar: { show: false } },
    plotOptions: {
      bar: {
        horizontal: true,
        distributed: true,
        dataLabels: { position: "center" },
      },
    },
    colors: ["#4f9cf9", "#6eaefc", "#90c2ff", "#b2d5ff"],
    dataLabels: {
      enabled: true,
      style: { colors: ["#fff"], fontSize: "14px" },
    },
    xaxis: {
      categories: labels,
      labels: { show: false },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: { show: false },
    legend: { show: false },
    grid: { show: false },
  };

  return <Chart options={options} series={[{ data: series }]} type="bar" height={120} />;
}

export default SourcingChart;


export function MultiProgressBar({ segments = [], monthYear }) {
  const { setIsModalOpen, user, apiHeaderJSON, apiHeaderFile } = useContext(AppContext);
  const navigate = useNavigate();
    const [atsIndex, setAtsIndex] = useState(false);
    useEffect(()=>{
    user?.filter((val, idx) => {
        if (val?.Module?.module_name === "ATS Pipeline") {
            setAtsIndex(idx);
            return val;
        }
    });
  },[user]);
  const total = segments.reduce((sum, s) => sum + s.value, 0);

  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, label: "", value: 0, color: "" });

  const handleMouseMove = (e, seg) => {
    setTooltip({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      label: seg.label,
      value: seg.value,
      color: seg.color,
    });
  };

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, visible: false }));
  };
  const handleClick = (e, val) => {
    
    const dates = getMonthStartAndEndDate(monthYear?.split('-')[0], monthYear?.split('-')[1]);
    const fromDate = dates?.startDate;
    const toDate = dates?.endDate;
    
    console.log(`monthYear fromDate, toDate =>`,monthYear, fromDate, toDate);
    navigate(`/ats-pipeline/${atsIndex}?status=${val?.label}&fromDate=${fromDate}&toDate=${toDate}`);
  };

  return (
    <div className="w-full max-w-xl mx-auto relative">
      {/* Progress Bar */}
      <div className="flex h-32 w-full rounded-lg overflow-hidden shadow">
        {segments.map((seg, i) => {
          const width = (seg.value < 1 ? 0.1 : seg.value / total) * 100;
          return (
            <div
              key={i}
              className={`${seg.color} relative flex items-center justify-center text-white text-sm font-semibold cursor-pointer`}
              style={{ width: `${width}%` }}
              onMouseMove={(e) => handleMouseMove(e, seg)}
              onMouseLeave={handleMouseLeave}
              onClick={(e) => handleClick(e, seg)}
            >
              {seg.value}
            </div>
          );
        })}
      </div>

      {/* Labels */}
      <div className="flex justify-between mt-3">
        {segments.map((seg, i) => (
          <div key={i} className="flex items-center gap-2">
            <span className={`w-3 h-3 rounded ${seg.color}`} />
            <span className="text-sm font-medium text-gray-700">{seg.label}</span>
          </div>
        ))}
      </div>

      {/* Tooltip */}
      {/* Tooltip */}
      {tooltip.visible && (
        <div
          className={`fixed px-2 py-1 rounded text-xs font-medium pointer-events-none bg-white shadow-md`}
          style={{ top: tooltip.y - 30, left: tooltip.x - 40 }}
        >
          <div className="flex items-center gap-2">
            <span className={`w-3 h-3 rounded ${tooltip.color}`} />
            <span className="text-sm font-medium text-gray-700">
              {tooltip.label} - {tooltip?.value}
            </span>
          </div>
        </div>
      )}
    </div>
  );
}


export function DonutChart({options, series}) {
  // console.log("series",series)
  // console.log("options",options)
  // const options = {
  //   chart: {
  //     type: "donut",
  //   },
  //   labels: labels,
  //   legend: {
  //     position: "bottom",
  //     markers: {
  //       radius: 12,
  //     },
  //     labels: {
  //       colors: "#000",
  //     },
  //   },
  //   colors: ["#3b82f6", "#60a5fa", "#93c5fd"],
  //   dataLabels: {
  //     enabled: false,
  //   },
  //   plotOptions: {
  //     pie: {
  //       donut: {
  //         size: "70%",
  //       },
  //     },
  //   },
  // };

  return (
    <div className="">
      <Chart options={options} series={series} type="donut" height={150} />
    </div>
  );
}